import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { LanguageContext } from '../../../../Contexts/LanguageContext';
import './ProductCards.css'

const ProductCards = ({ product }) => {
    const { name, details, img, genericName, id, banglaDetails } = product;
    const history = useHistory()
    const [isBangla, setIsBangla] = useContext(LanguageContext)
    return ( 
        <div className="pt-4 m-auto">
            <div className="row m-auto">
                <div className="col-md-3">
                    <div className="card mb-4" style={{ width: "18rem", height: "25rem" }}>
                        <img src={img} className="card-img-top" alt="..." />
                        <div className="card-body">
                            <h5 className="card-title">{name}</h5>
                            <p className="card-text">{isBangla ? banglaDetails : details}</p>
                            <a href={'/product-detail/' + id} className="read-more-btn">{isBangla ? "আরও পড়ুন" : "Read More"}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductCards;